import fscreen from 'fscreen';
import { useEffect, useRef, useState } from 'react';

import { isMobile } from '../../utils/isMobile';

const mq = window.matchMedia('(orientation:landscape)');

const isLandscape = (): boolean => {
	try {
		return /landscape/.test(screen.orientation.type);
	} catch (e) {}

	return window.matchMedia('(orientation:landscape)').matches;
};
type ReturnType = {
	panel: React.RefObject<HTMLDivElement>;
	fullscreen: boolean;
	setFullscreen: React.Dispatch<React.SetStateAction<boolean>>;
};
export const useFullscreen = (): ReturnType => {
	const panel = useRef<HTMLDivElement>(null);
	const [fullscreen, setFullscreen] = useState(isMobile && isLandscape);

	// iphone
	useEffect(() => {
		if (isMobile && !screen.orientation) {
			const f = ({ matches }: { matches: boolean }): void => {
				setFullscreen(matches);
			};
			if (mq.addEventListener) {
				mq.addEventListener('change', f);
			} else if (mq.addListener) {
				mq.addListener(f);
			}
			return (): void => {
				if (mq.removeEventListener) {
					mq.removeEventListener('change', f);
				} else if (mq.removeListener) {
					mq.removeListener(f);
				}
			};
		}
	}, []);

	// non-iphone
	useEffect(() => {
		if (isMobile && panel.current && screen.orientation) {
			const f = (): void => {
				if (isLandscape() && panel.current) {
					setFullscreen(true);
					fscreen.requestFullscreen(panel.current);
				} else {
					setFullscreen(false);
					fscreen.fullscreenElement && fscreen.exitFullscreen();
				}
			};
			screen.orientation.addEventListener('change', f);

			return (): void => screen.orientation.removeEventListener('change', f);
		}
	}, []);

	// for escape button press
	useEffect(() => {
		if (!isMobile && screen.orientation) {
			const f = (): void => {
				if (!fscreen.fullscreenElement) {
					setFullscreen(false);
				}
			};
			fscreen.addEventListener('fullscreenchange', f);

			return (): void => {
				fscreen.removeEventListener('fullscreenchange', f);
			};
		}
	}, []);

	//desktop
	useEffect(() => {
		if (!isMobile) {
			if (fullscreen && panel.current && fscreen.fullscreenEnabled) {
				fscreen.requestFullscreen(panel.current);
			} else if (fscreen.fullscreenElement) {
				fscreen.exitFullscreen();
			}
		}
	}, [fullscreen]);

	return { panel, fullscreen, setFullscreen };
};
